import Milenialc1 from "./milenialc (1).webp";
import Milenialc2 from "./milenialc (2).webp";
import Milenialc3 from "./milenialc (3).webp";
import Milenialc4 from "./milenialc (4).webp";
import Milenialc5 from "./milenialc (5).webp";
import Milenialc6 from "./milenialc (6).webp";
import Milenialc7 from "./milenialc (7).webp";

const milenialc = [
  Milenialc1,
  Milenialc2,
  Milenialc3,
  Milenialc4,
  Milenialc5,
  Milenialc6,
  Milenialc7,
];

export default milenialc;
